export const codeModule = {
    DISPROUTES: 'Диспетчер маршрутов',
    DANGERCARGO: 'Опасные грузы',
    RIDERSHIP: 'Пассажирские перевозки'
}